import { forwardRef } from 'react';
import type { SyntheticEvent } from 'react';
import { Field, ErrorMessage, FieldProps } from 'formik';
import { Flex } from 'antd';
import clsx from 'clsx';
import type { InputRef } from 'antd';
import { MaskedInput } from 'antd-mask-input';
import TextError from 'components/TextError';
import FieldLabel from 'components/FieldLabel';
import If from 'components/If';
import { MaskedInputProps } from 'utils/globalTypes';
import styles from './index.module.scss';

type MaskChangeEventType = SyntheticEvent & {
  maskedValue: string;
  unmaskedValue: string;
};

const InputMask = forwardRef<InputRef, MaskedInputProps>((props, ref) => {
  const {
    label,
    name,
    showErrMsg = true,
    info,
    maskOptions = {},
    qaSelector,
    className,
    ...rest
  } = props;
  const maskOptionsObj = {
    lazy: true,
    ...maskOptions,
  };
  const inputClassName = clsx(styles.maskedInput, className);
  return (
    <Flex vertical align='flex-start' className='formFieldContainer'>
      <FieldLabel label={label} info={info} />
      <Field name={name}>
        {({ field, meta, form }: FieldProps) => {
          const { setFieldValue } = form;
          const fieldStatus = meta.touched && meta.error ? 'error' : '';
          const onChange = (e: MaskChangeEventType) => {
            setFieldValue(name, e.unmaskedValue);
          };
          return (
            <MaskedInput
              ref={ref}
              id={name}
              type='text'
              size='large'
              status={fieldStatus}
              {...field}
              {...rest}
              className={inputClassName}
              maskOptions={maskOptionsObj}
              onChange={onChange}
              data-qa-selector={qaSelector}
            />
          );
        }}
      </Field>
      <If condition={showErrMsg}>
        <ErrorMessage name={name}>
          {(msg) => <TextError msg={msg} qaSelector={`${qaSelector}-error`} />}
        </ErrorMessage>
      </If>
    </Flex>
  );
});

export default InputMask;
